import { useQuery } from 'react-query'
import client from './api-client';

const queryConfig = {
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
}

async function fetchIrrigationTypes() {
  const data = await client(`irrigation-types/`)
  return data
}

export function useIrrigationTypes() {
  return useQuery(['irrigation-types'], () => fetchIrrigationTypes(), {
    refetchAllOnWindowFocus: false,
    ...queryConfig
  });
}
